<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6btMCs/tc-custom/9781504093439.jpg?1718081189854" alt="This image is the cover for the book From the Inside Out"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">From the Inside Out
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Fifteen survivors of the September 11 attack on the World Trade Center share their dramatic stories of that fateful day.</b></p><p> On September 11, 2001, tens of thousands in New York City awakened to a beautiful Tuesday morning. Just like any other day, they completed their morning routines and headed to work. For Erik Ronningen, that was his job with the Port Authority of New York and New Jersey at the World Trade Center. Ronningen had a big, career-changing meeting scheduled for 9 A.M. </p><p> At 8:46 A.M., Erik was on the seventy-first floor of the North Tower when American Airlines Flight 11 struck the building. As acrid smoke filled the building, he made his way downstairs, hoping to get to the Security Command Center in the basement of the South Tower. However, he was unable to reach it and was the last person to exit the South Tower alive . . . </p> In <i>From the Inside Out</i>, Ronningen shares the story of his harrowing escape, along with stories from fourteen other survivors. These gripping accounts chronicle individuals displaying courage and heroism when their ordinary day quickly became a fiery scramble for survival.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Erik O. Ronningen
      </h2>
      
      <p class="authorDescription body article">Erik Ronningen was the last person to escape the South Tower of the World Trade Center on September 11th before it collapsed. After the dust settled, he immersed himself in the urgent task of ascertaining who and who did not survive. To facilitate this, he developed a victim identification&ndash;database reconstituted from the damaged World Trade Center access control system and delivered the results to the 9/11 Commission. He recounted his and other survivor&rsquo;s experiences in his Ella Dickey Literacy Award&ndash;winning book <I>From the Inside Out</I>. He has traveled the world as a public speaker and has keynoted at various national and international security venues, high schools, elementary schools, and church groups, as well as Navy Seal Teams, Army Delta Teams, and the FBI&rsquo;s Terrorist Screening Center. He is currently the Principal of Consolidated Consulting Group, LLC, a security-consulting firm and service provider of Life-Safety Personnel Assurance. He lives in Mamaroneck, NY.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Welcome Rain Publishers and Flipside Digital Content Company Incorporated
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?388311b6